<template>
    <div class="futureCityDescriptionContent">
      <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">未来城介绍</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
      </div>
      <div class="fcd_blockContent1 e-flex">
        <div class="fcd_planRangeLeft">
          <div class="fcd_blockTitle">规划范围</div>
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未来科学城位于北京市昌平区南部平原地区，规划范围约170.6平方公里，东至京承高速，与顺义区接壤，距首都机场10公里；南至回南北路附近村界，与回龙观、天通苑两大居住区相邻，距北五环10公里：西至京新高速，与海淀区接壤；北至北六环。</div>
        </div>
        <img class="fcd_blockImg1" src="@/assets/images/parkDescription/block1.png">
      </div>
      <div class="fcd_blockContent2 e-flex">
        <div class="fcd_blockContent2Center">
          <div class="fcd_blockTitle">定位目标</div>
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未来科学城作为北京建设国际科技创新中心枢纽型主平台，地处中关村科学城和怀柔科学城的连接点上，聚焦技术创新，成果承接转化优势明显，战略位置突出，是首都创新链条的重要一环。未来科学城具有“三区”叠加优势，是中关村国家自主创新示范区的重要政策区之一，也是北京自由贸易试验区科技创新片区主阵地、国家服务业扩大开放综合示范区主窗口，将汇聚国际一流创新型企业、国际一流研发机构和国际一流人才，构筑良好创新创业生态，形成宜居宜业环境，发挥辐射带动作用，建设技术创新领航区、协同创新先行区、技术人才集聚区与创新创业示范城，打造全球领先的技术创新高地。</div>
        </div>
      </div>
      <div class="e-flex" style="justify-content: center;">
        <img class="fcd_blockContent2Img" src="@/assets/images/parkDescription/block2.png">
      </div>
      <div class="fcd_blockContent3 e-flex">
        <div class="fcd_planRangeLeft3">
          <div class="fcd_blockTitle">战略布局</div>
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未来科学城整体规划呈现“两区一心”空间格局，研发产业聚焦“两谷一园”创新布局。“东西两区”是未来科学城的主体承载区，建设功能完备、宜居宜业的研发创新社区；“一心”是未来科学城的生态绿心，连接东西两区，共同构建蓝绿交织、水城共融的生态发展格局。</div>
        </div>
        <img class="fcd_blockImg3" src="@/assets/images/parkDescription/block3.png">
      </div>
      <div class="fcd_blockContent4 e-flex">
        <img class="fcd_blockImg4" src="@/assets/images/parkDescription/block4.png">
        <div class="fcd_planRangeLeft4">
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;其中，东区规划面积44.3平方公里，重点布局先进能源产业，打造能源产业战略支撑点，建设具有国际影响力的“能源谷”，已形成科技研发、技术服务、成果转化全周期创新链条，成为北京十大高精尖产业先进能源细分领域核心承载区，快速抢占能源领域国际科技高地，打造中央企业创新创业主阵地、绿色可持续发展先行区、国际先进能源产业集聚区。编制实施《昌平区先进能源产业提质增效行动计划（2022-2025年）》，主动践行国家“双碳”战略，聚焦三大赛道，发展提升能源互联网高成长关键赛道，巩固壮大化石能源清洁高效利用、风电光伏增长型成熟赛道，储备布局氢能、储能、碳固存培育型前沿赛道，打造氢能和能源互联网产业集群，助力国家能源转型发展。</div>
        </div>
      </div>
      <div class="fcd_blockContent5 e-flex">
        <div class="fcd_planRangeLeft5">
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;西区规划面积62.5平方公里，重点布局医药健康产业，打造具有全球竞争力的医药健康产业发展高地，建设具有全球领先水平的“生命谷”，已形成从基础研究到终端医疗的全产业链资源聚集，成为蛋白质组学、基因组学、脑科学等生命科学基础研究高地，打造生命科学领域原始创新的策源地、全球医药创新资源的聚集地。编制实施《昌平区医药健康产业倍增行动计划（2022-2025年）》，把握生物技术、数字技术两大核心驱动力，围绕前沿技术、医疗器械、美丽健康三条赛道持续发力，全面形成医药健康千亿级产业集群。</div>
        </div>
        <img class="fcd_blockImg5" src="@/assets/images/parkDescription/block5.png">
      </div>
      <div class="fcd_blockContent6 e-flex">
        <img class="fcd_blockImg6" src="@/assets/images/parkDescription/block6.png">
        <div class="fcd_planRangeLeft6">
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;西区沙河高教园区打造世界一流的高教园区，重点抓好设施配套和服务提升，建设结构合理、要素齐全、职住平衡、充满活力的科教及产业融合新城，已成为未来科学城的基础研究重镇、人才培养高地。</div>
        </div>
      </div>
      <div class="fcd_blockContent7 e-flex">
        <div class="fcd_blockContent7Center">
          <div class="fcd_blockCommon">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;按照北京市委市政府赋予未来科学城的战略定位要求，“十四五”时期，未来科学城将秉承“ 攻关未来科技、发展未来产业、集聚未来人才”的初心使命，围绕“全球领先的技术创新高地、协同创新先行区、创新创业示范城”目标，加快实施生命技术赶超工程，大力推动国际先进能源产业集聚，全力支撑首都北京2025年基本建成国际科技创新中心。</div>
        </div>
      </div>
      <div class="e-flex" style="justify-content: center;">
        <img class="fcd_blockContent7Img" src="@/assets/images/parkDescription/block7.png">
      </div>
    </div>
  </template>
  
  <script>
    import '../../styles/parkDescription.css'
    export default {
      name: 'futureCityDescription',
      data () {
        return {
          
        }
      },
      created() {
        
      },
      methods: {
        
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/parkDescription/futureCityDescription.vue